import { useQuery } from "@tanstack/react-query";
import { getAPIFilters } from "PFApp/use_filtered_collection/format_filters";
import {
  fetchSkillsFrameworksSuggestedSkills,
  SkillsFrameworksSuggestedSkillsResponse
} from "PFCore/services/skills/fetch_skills_frameworks_suggested_skills";
import { Id } from "PFTypes/id";
import { QueryParams } from "PFTypes/query_params";
import { QueryOptions } from "PFTypes/request_options";

import { skillsKeys } from "./query_keys";

export const useSkillsFrameworksSuggestedSkills = (
  id: Id,
  params: QueryParams = { page: 1 },
  options: QueryOptions<SkillsFrameworksSuggestedSkillsResponse> = {}
) => {
  const queryKey = skillsKeys.framework(params);

  return useQuery(
    queryKey,
    () => fetchSkillsFrameworksSuggestedSkills(id, { ...params, filters: getAPIFilters(params.filters) }),
    {
      placeholderData: {
        entries: []
      },
      ...options
    }
  );
};
